.multiSelect {
	position: relative;
	width: 100%;
	font-family: 'Ringside', sans-serif;
	font-size: 16px;
	line-height: 18px;
	.trigger {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		border: 1px solid #d8e0e8;
		background: #fff;
		padding: 10px 12px;
		font: inherit;
		line-height: 1.15;
		text-align: left;
		cursor: pointer;
		transition:
			border-color 0.2s ease,
			box-shadow 0.2s ease;

		&:hover,
		&:focus-visible {
			// border-color: #0073ee;
			// box-shadow: 0 0 0 2px rgba(0, 115, 238, 0.15);
			outline: none;
		}
	}

	.icon {
		font-size: 12px;
		line-height: 1;
		transition: transform 0.3s ease;
	}

	.options {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		max-height: 0;
		overflow: hidden;
		opacity: 0;
		pointer-events: none;
		border: 1px solid #d8e0e8;
		border-top: none;
		background: #fff;
		transform: translateY(-6px);
		transition:
			max-height 0.28s ease,
			opacity 0.2s ease,
			transform 0.28s ease,
			padding 0.28s ease;
		z-index: 10;
	}

	.opcio {
		display: flex;
		align-items: center;
		gap: 8px;
		font: inherit;
		line-height: 1.2;
		text-align: left;
		padding: 9px 10px;
		background: #fff;
		color: #000;
		cursor: pointer;
		transition:
			background-color 0.2s ease,
			border-color 0.2s ease,
			color 0.2s ease;

		input[type='checkbox'] {
			accent-color: #0073ee;
			width: 14px;
			height: 14px;
			margin: 0;
			flex: 0 0 auto;
		}

		&:hover,
		&:focus-visible {
			background: #f4f6f8;
			color: #000;
		}
	}
}

.obert {
	.icon {
		transform: rotate(180deg);
	}
	.trigger {
		border-radius: 4px 4px 0 0;
		border-bottom: none;
	}

	.options {
		max-height: 320px;
		overflow-y: auto;
		overflow-x: hidden;
		opacity: 1;
		pointer-events: auto;
		transform: translateY(0);
		border-radius: 0 0 4px 4px;
	}
}
